import { Http, EndPoints, getParams, TypeParams, TypeResource, CompanyID, ID, CompanyDebt } from '../../core/utils';
import { CompanyListItem, CompanyDetail, postNewCompany, patchCompany, patchCompanyResponse, CompaniesConfigurations, CompanyStopConfig } from '../models/Companies';


export const CompaniesService = {
    getAllCompanies: (): Promise<Array<CompanyListItem>> =>
        Http.get(`${TypeResource.COMPANIES}${EndPoints.CompaniesUrls.LIST}`).then(response => response.data),

    getVehiclesForCompanies: (ids: ID[]): Promise<any> =>
        Http.get(`${EndPoints.CompaniesUrls.COMPANIES_VEHICLES}`, {
            params: getParams([
                {
                    key: TypeParams.IDS,
                    value: joinParams(ids, ',')
                },
            ])
        }).then(response => response.data),

    getCompanyById: (companyId: ID): Promise<CompanyDetail> =>
        Http.get(`${EndPoints.CompaniesUrls.COMPANIES}`, {
            params: getParams([{ key: TypeParams.ID, value: companyId }])
        }).then(response => response.data),

    getCompaniesConfigurations: (): Promise<CompaniesConfigurations> =>
        Http.get(`${EndPoints.CompaniesUrls.COMPANIES_CONFIGURATIONS}`)
            .then(response => response.data),

    setStopSettingForCompany: (config: CompanyStopConfig): Promise<{message:string}> =>
        Http.patch(`${EndPoints.CompaniesUrls.COMPANIES_STOP_SETINGS}`, config).then(response => response.data),

    postCompany: (company: postNewCompany): Promise<any> =>
        Http.post(`${EndPoints.CompaniesUrls.COMPANIES}`, company).then(response => response.data),

    patchCompany: (company: patchCompany, companyId: ID): Promise<patchCompanyResponse> =>
        Http.patch(`${EndPoints.CompaniesUrls.COMPANIES}`, company, 
        {
            params: getParams([{ key: TypeParams.ID, value: companyId }])
        }).then(response => response.data),

    deactivateJourney: (companyId: ID): Promise<any> =>
        Http.post(`${EndPoints.CompaniesUrls.COMPANIES}${EndPoints.JourneysUrls.JOURNEYS_DEACTIVATE}`, null, {
            params: getParams([{ key: TypeParams.ID, value: companyId }])
        }).then(response => response.data),

    activateJourneys: (companyId: ID, configuration: {calc_type: number}): Promise<any> =>
        Http.post(`${EndPoints.CompaniesUrls.COMPANIES}${EndPoints.JourneysUrls.JOURNEYS_ACTIVATE}`, configuration, {
            params: getParams([{ key: TypeParams.ID, value: companyId }])
        }).then(response => response.data),

    setCompaniesDebt: (companiesIds: number[], configuration: CompanyDebt): Promise<any> =>
        Http.post(`${EndPoints.CompaniesUrls.COMPANIES_DEBT}`, configuration, {
            params: getParams([{ key: TypeParams.COMPANY_IDS, value: joinParams(companiesIds, ',') }])
        }).then(response => response.data),

    suspendServices: (companiesIds: number[]): Promise<any> =>
        Http.post(`${EndPoints.CompaniesUrls.COMPANIES_SUSPEND_SERVICES}`, {}, {
            params: getParams([{ key: TypeParams.COMPANY_IDS, value: joinParams(companiesIds, ',') }])
        }).then(response => response.data),

    restoreServices: (companiesIds: number[]): Promise<any> =>
        Http.post(`${EndPoints.CompaniesUrls.COMPANIES_RESTORE_SERVICES}`, {}, {
            params: getParams([{ key: TypeParams.COMPANY_IDS, value: joinParams(companiesIds, ',') }])
        }).then(response => response.data),

    activateMDPService: (companyId: ID, username: string, password: string): Promise<any> =>
        Http.post(`${EndPoints.CompaniesUrls.COMPANIES_JOURNEYS_MDP_ACTIVE}`, {
            username: username,
            password: password
        }, {
            params: getParams([
                { key: TypeParams.ID, value: companyId },
            ])
        }).then(response => response.data),

    activateGuardianService: (companyId: ID, username: string, password: string): Promise<any> =>
        Http.post(`${EndPoints.CompaniesUrls.GUARDIAN_MODULE}`, {
            username: username,
            password: password
        }, {
            params: getParams([
                { key: TypeParams.ID, value: companyId },
            ])
        }).then(response => response.data),

    deactivateGuardian: (companyId: ID): Promise<any> =>
        Http.delete(`${EndPoints.CompaniesUrls.GUARDIAN_MODULE}`, {
            params: getParams([{ key: TypeParams.ID, value: companyId }])
        }).then(response => response.data),

    patchGuardianService: (companyId: ID, username: string, password: string): Promise<any> =>
        Http.patch(`${EndPoints.CompaniesUrls.GUARDIAN_MODULE}`, {
            username: username,
            password: password
        }, {
            params: getParams([
                { key: TypeParams.ID, value: companyId },
            ])
        }).then(response => response.data),

    patchMDPService: (companyId: ID, username: string, password: string): Promise<any> =>
        Http.patch(`${EndPoints.CompaniesUrls.COMPANIES_JOURNEYS_MDP_ACTIVE}`, {
            username: username,
            password: password
        }, {
            params: getParams([
                { key: TypeParams.ID, value: companyId },
            ])
        }).then(response => response.data),

    deactivateMDPService: (companyId: ID): Promise<any> =>
        Http.delete(`${EndPoints.CompaniesUrls.COMPANIES_JOURNEYS_MDP_ACTIVE}`, {
            params: getParams([{ key: TypeParams.ID, value: companyId }])
        }).then(response => response.data),
};

const joinParams = (ids: CompanyID[] | string[], separator: string) => ids.join(separator);
